import { render, staticRenderFns } from "./OwCategoryPackage.vue?vue&type=template&id=4bd4cbb6&"
import script from "./OwCategoryPackage.vue?vue&type=script&lang=js&"
export * from "./OwCategoryPackage.vue?vue&type=script&lang=js&"
import style0 from "./OwCategoryPackage.vue?vue&type=style&index=0&id=4bd4cbb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports